import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from 'src/app/services/validation.service';
import { MoiaCaptchaComponent } from '../moia-captcha/moia-captcha.component';
import { TranslateService } from '@ngx-translate/core';

  @Component({
    selector: 'declaration-signature',
    templateUrl: './declaration-signature.component.html'
  })
  export class DeclarationSignatureComponent implements OnInit {
    @Input() form: FormGroup = null;
    @Input() showCaptcha = false;
    @Output() onreset = new EventEmitter();
    @Output() onsubmit = new EventEmitter();
    @ViewChild(MoiaCaptchaComponent) private captchaComponent: MoiaCaptchaComponent;
    confirm_msg = "";
    isSubmitted = false;
    
    constructor ( translate: TranslateService) {
		this.confirm_msg ="האם בטוח ברצונך לנקות את הטופס?"
    }

    ngOnInit(): void {
        this.form.addControl('declaration_check', new FormControl('', [ValidationService.CheckedRequired])); 
    }

    public get f() {
        return this.form.controls;  
    }

    onReset() {
      if (confirm(this.confirm_msg))
        this.onreset.emit();
    }

    onSubmit() {
        if (this.showCaptcha) {
          let captcha = this.captchaComponent.GetResponse();
          this.isSubmitted = true;
          if (!captcha) 
            return;
          this.form.controls.captcha.setValue(captcha);
        }
        this.onsubmit.emit();
    }
  }